var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import moment from "moment";
import { get } from "lodash";
import { Card, Hr } from "@irati/ui/src/Layout";
import { H4 } from "@irati/ui/src/Headings";
import { FormattedMessage, FormattedDate } from "@irati/utils/lang";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { Image } from "../../ui/Image";
import { getSentimentById } from "../../helpers/Sentiment";
import helper from "../../helpers/DriverIcon";
import FlexWrapper from "../../ui/Layout/FlexWrapper";
import { Para } from "../../ui/Labels";
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "]))));
var InnerWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  ", ";\n  padding: ", " ", ";\n"], ["\n  width: 100%;\n  ", ";\n  padding: ", " ",
    ";\n"])), function (_a) {
    var fillSpace = _a.fillSpace;
    return fillSpace && "flex:1";
}, function (_a) {
    var noPadding = _a.noPadding;
    return (noPadding ? "none" : "10px 0");
}, minWidthMedia.tablet(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0 15px;\n    width:auto;\n  "], ["\n    padding: 0 15px;\n    width:auto;\n  "]))));
var DateWrapper = styled(Para)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: ", ";\n  ", "\n"], ["\n  display: ", ";\n  ",
    "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? "block" : "none");
}, minWidthMedia.tablet(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: ", ";\n  "], ["\n    display: ", ";\n  "])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? "none" : "block");
}));
var DriverName = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  white-space: nowrap;\n  padding-left: 10px;\n"], ["\n  white-space: nowrap;\n  padding-left: 10px;\n"])));
var Comment = function (_a) {
    var comment = _a.comment;
    if (!comment)
        return null;
    var tags = comment.tags, createdAt = comment.createdAt;
    var sentiment = tags.find(function (tag) { return tag.type === "sentiment"; });
    var question = get(comment, "userSurvey.preferences.driverCommentTitle");
    var isCustomDriver = get(comment, "driver.contentId") === "insights.driver.custom";
    var date = React.createElement(FormattedDate, { value: moment(createdAt).toDate(), month: "numeric", day: "numeric", year: "numeric" });
    return (React.createElement(Card, { small: true },
        React.createElement(H4, null,
            " ",
            question,
            " "),
        React.createElement(Hr, null),
        React.createElement(Wrapper, null,
            React.createElement(InnerWrapper, null,
                React.createElement(FlexWrapper, { justify: "space-between" },
                    sentiment ? React.createElement(Image, { src: getSentimentById("positive").icon, alt: "Profile image", size: 29 }) : "-",
                    React.createElement(DateWrapper, { isMobile: true, flush: true },
                        " ",
                        date,
                        " "))),
            React.createElement(InnerWrapper, { fillSpace: true },
                React.createElement(Para, { medium: true }, comment.text)),
            !isCustomDriver && (React.createElement(InnerWrapper, null,
                React.createElement(FlexWrapper, { align: "center" },
                    React.createElement(Image, { src: helper.getDriverIcon(comment.driver.contentId), alt: "Driver image", size: 45 }),
                    React.createElement(DriverName, null,
                        " ",
                        React.createElement(FormattedMessage, { id: comment.driver.contentId + ".name" }),
                        " ")))),
            React.createElement(InnerWrapper, { noPadding: true },
                React.createElement(DateWrapper, { flush: true },
                    " ",
                    date,
                    " ")))));
};
export default Comment;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
